import moment from 'moment'
export const state = {
    contaPagar: {
        fornecedor_id: '',
        situacao: 'EM ABERTO',
        numero_documento: '',
        data_vencimento: moment().format('YYYY-MM-DD'),
        data_emissao: moment().format('YYYY-MM-DD'),
        data_pagamento: moment().format('YYYY-MM-DD'),
        valor: '',
        forma_pagamento: '',
        ocorrencia_tipo: '',
        ocorrencia: 'PARCELA ÚNICA',
        ocorrencia_quantidade: 1,
        numero_parcela: 1,
        ocorrencia_quantidade: '',
        numero_parcela: '',
        ocorrencia_quantidade: '',
        informacoes: '',
        anexo: '',
        grupo_id: '',
        portador_id: ''
    },
    contasPagar: [],
    contaPagarSituacoes: [
        '',
        'EM ABERTO',
        'PAGO'
    ],
    contaPagarPortadores: [
        '',
        'ADMINISTRADORA',
        'BANCO',
        'CAIXA'
    ],
    contaPagarFormasPagamento: [
        'DINHEIRO',
        'CARTÃO DE CRÉDITO',
        'CARTÃO DE DÉBITO',
        'CHEQUE',
        'BOLETO',
    ],
    
    contaPagarOcorrenciaTipos: [
        'PARCELA ÚNICA',
        'PARCELAR',
        // 'REPETIR'
    ],
    contaPagarOcorrencias: [
        'DIÁRIA',
        'SEMANAL',
        'MENSAL',
        'BIMESTRAL',
        'TRIMESTRAL',
        'SEMESTRAL',
        'ANUAL',
    ],
    modalExcluirContaPagar: false,
    modalCadastrarContaPagar: false,
    modalBaixaContaPagar: false,
    showInputAnexo: true
}

export default {}